import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const tabs = {
  // subsystem-common
  commonWork: ItemName.of([Locale.ja, '業務共通']),
  operationManagement: ItemName.of([Locale.ja, '運用管理']),
  mstManagement: ItemName.of([Locale.ja, 'マスタ管理']),

  // fa
  fixedAssetManagement: ItemName.of([Locale.ja, '固定資産管理']),
  leaseAssetManagement: ItemName.of([Locale.ja, 'リース資産管理']),
  leaseContractManagement: ItemName.of([Locale.ja, 'リース契約管理']),
};

const blockTitles = {
  // subsystem-common
  variousSettings: ItemName.of([Locale.ja, '各種設定']),

  // system-management
  userMaintenance: ItemName.of([Locale.ja, 'ユーザメンテナンス']),
  securitySettings: ItemName.of([Locale.ja, 'セキュリティ']),

  // fa
  financialStatements: ItemName.of([Locale.ja, '財務諸表']),
  balanceBroughtForward: ItemName.of([Locale.ja, '繰越']),
  reference: ItemName.of([Locale.ja, '照会']),
  form: ItemName.of([Locale.ja, '帳票']),
  report: ItemName.of([Locale.ja, 'レポート']),
  manageContractArticles: ItemName.of([Locale.ja, '契約／物件管理']),
  changeInformation: ItemName.of([Locale.ja, '情報変更']),
  reLeaseAndExpired: ItemName.of([Locale.ja, '再リース及び満了']),
  cancellationBeforeMaturity: ItemName.of([Locale.ja, '中途解約']),
  cancelRegistration: ItemName.of([Locale.ja, '登録取消']),
  importFile: ItemName.of([Locale.ja, 'ファイル取込']),
  increDecreEntry: ItemName.of([Locale.ja, '増減登録']),
  registration: ItemName.of([Locale.ja, '登録']),
  migrateBalance: ItemName.of([Locale.ja, '残高移行']),
  workMstMaintenance: ItemName.of([Locale.ja, '業務マスタメンテナンス']),
  segmentMstMaintenance: ItemName.of([Locale.ja, 'セグメントマスタメンテナンス']),
  manageOperation: ItemName.of([Locale.ja, '運用管理']),
};

const functions = {
  // system-management
  loginUserMst: ItemName.of([Locale.ja, 'ログインユーザ']),
  roleMst: ItemName.of([Locale.ja, 'ロール']),
  policyMst: ItemName.of([Locale.ja, 'ポリシー']),
  companyInfo: ItemName.of([Locale.ja, '会社情報']),
  passwordPolicy: ItemName.of([Locale.ja, 'パスワードポリシー']),
  sso: ItemName.of([Locale.ja, 'SSO']),

  /**
   * fa
   */
  // commonWork
  confirmSettlementStatus: ItemName.of([Locale.ja, '決算状況確認']),
  balanceBroughtForwardAtBeginning: ItemName.of([Locale.ja, '期首繰越']),
  // fixedAssetManagement
  increaseDecreaseSummary: ItemName.of([Locale.ja, '増減合計表']),
  fixedAssetLedgerIndividual: ItemName.of([Locale.ja, '固定資産台帳(1件別明細)']),
  depreciationExpensesSummary: ItemName.of([Locale.ja, '償却費集計表']),
  fixedAssetImpairmentStatement: ItemName.of([Locale.ja, '減損明細表']),
  depreciationItemChange: ItemName.of([Locale.ja, '償却項目変更']),
  impairmentLossEntry: ItemName.of([Locale.ja, '減損損失計上']),
  increDecreCancel: ItemName.of([Locale.ja, '増減取消']),
  fixedAssetListInquiry: ItemName.of([Locale.ja, '一覧照会']),
  // leaseAssetManagement
  leaseLiabilityLedger: ItemName.of([Locale.ja, 'リース債務台帳']),
  laArticlePrincipalRepaymentSchedule: ItemName.of([Locale.ja, 'リース物件元本返済予定表']),
  laArticleLeaseFeePaymentList: ItemName.of([Locale.ja, 'リース物件リース料支払リスト']),
  laContractPaymentConfirmationForm: ItemName.of([Locale.ja, 'リース契約支払確認表']),
  leaseLiabilityEstimateChange: ItemName.of([Locale.ja, 'リース債務見積変更']),
  // leaseContractManagement
  referenceContractList: ItemName.of([Locale.ja, '契約一覧照会']),
  referenceArticleList: ItemName.of([Locale.ja, '物件一覧照会']),
  referenceContractRegistrationHistory: ItemName.of([Locale.ja, '契約登録履歴照会']),
  referenceArticleRegistrationHistory: ItemName.of([Locale.ja, '物件登録履歴照会']),
  contractLedgerIndividual: ItemName.of([Locale.ja, '契約台帳(1件別明細)']),
  articleLedgerIndividual: ItemName.of([Locale.ja, '物件台帳(1件別明細)']),
  unUpdatedDataList: ItemName.of([Locale.ja, '未更新データ一覧']),
  laArticleListSearch: ItemName.of([Locale.ja, '物件台帳(1件別明細)']),
  startRegistration: ItemName.of([Locale.ja, '開始登録']),
  changeContractInformation: ItemName.of([Locale.ja, '契約情報変更']),
  changeArticleInformation: ItemName.of([Locale.ja, '物件情報変更']),
  releaseAndContractExpiration: ItemName.of([Locale.ja, '再リース及び契約満了']),
  cancellationBeforeMaturity: ItemName.of([Locale.ja, '中途解約']),
  cancelRegistration: ItemName.of([Locale.ja, '登録取消']),
  laMigrateBalanceImport: ItemName.of([Locale.ja, 'リース残高移行(取込)']),
  laMigrateBalanceDelete: ItemName.of([Locale.ja, 'リース残高移行削除']),
  // mstManagement
  leaseCompanyMst: ItemName.of([Locale.ja, 'リース会社']),
  categoryMst: ItemName.of([Locale.ja, '種類']),
  subCategoryMst: ItemName.of([Locale.ja, '分類']),
  businessConnectionMst: ItemName.of([Locale.ja, '取引先']),
  locationMst: ItemName.of([Locale.ja, '設置場所']),
  nameMst: ItemName.of([Locale.ja, '名称']),
  // operationManagement
  jobMonitorCompany: ItemName.of([Locale.ja, 'ジョブ監視(会社)']),
  articleManagementSettings: ItemName.of([Locale.ja, '物件管理']),
  operationControl: ItemName.of([Locale.ja, '運用制御']),
  accountingPolicy: ItemName.of([Locale.ja, '会計方針']),
  mst: ItemName.of([Locale.ja, 'マスタ']),
  optionItem: ItemName.of([Locale.ja, '任意項目']),
  holiday: ItemName.of([Locale.ja, '休日']),
  interestRate: ItemName.of([Locale.ja, '利子率']),
};

export { blockTitles, functions, tabs };
